import * as React from "react";
//import VolumeControllerProps from './VolumeControllerProps';
import VolumeControllerState from './volume-controller-state';
//import "./volume-controller.css";
import { RangeComponent } from "@att-bit/gvp.atoms.range-component";
// import IconSvg from '@idp/duc/components/atoms/IconSvg';
import {
  volumeIconDefault,
  volumeIconFull,
  volumeIconHalf,
  volumeIconLow,
} from "./constants-icons";
import { IconSvg, IconSvgSizes } from "@att-bit/duc.components.icon-svg";

export type VolumeControllerProps = {
  data: VolumeControllerData;
  events: VolumeControllerEvents;
  options?: VolumeControllerOptions;
  testId?: string;
};

export type VolumeControllerData = {
  mute: boolean | undefined;
  volume: number;
};

export type VolumeControllerOptions = {
  buttonClassName?: string;
  volumnRangeClassName?: string;
  modal?: boolean;
};

export type VolumeControllerEvents = {
  onClick?(mute: boolean, volumn: number): void;
  onVolumeChange?(mute: boolean, volumn: number): void;
};

export class VolumeController extends React.Component<VolumeControllerProps, VolumeControllerState> {
  state: VolumeControllerState;

  constructor(props: VolumeControllerProps) {
    super(props);
    this.state = {
      mute: this.props.data.mute || false,
      volume: this.props.data.volume || 75,
    };
    this.renderOnOffButton = this.renderOnOffButton.bind(this);
    this.handlevolumeClick = this.handlevolumeClick.bind(this);
    this.handlevolumeRange = this.handlevolumeRange.bind(this);
  }

  render() {
    return (
      <React.Fragment>
        {this.renderOnOffButton(this.state.volume)}
        {this.renderVolumRange()}
        {/*
              // @ts-ignore */}
              <style jsx global>{`
              .VolumeController__volumeController {
                flex: 0 1 auto;
                order: 1;
              }
              .VolumeController__volumeController:hover .VolumeController__volumeRange,
              .VolumeController__volumeController:focus .VolumeController__volumeRange,
              .VolumeController__volumeController.VolumeController__hasFocus
                .VolumeController__volumeRange {
                width: 120px;
                -webkit-transition: width 0.52s;
                /* Safari */
                transition: width 0.52s;
              }
              .VolumeController__volumeController:hover
                .VolumeController__volumeRange
                .VolumeController__button,
              .VolumeController__volumeController:focus
                .VolumeController__volumeRange
                .VolumeController__button,
              .VolumeController__volumeController.VolumeController__hasFocus
                .VolumeController__volumeRange
                .VolumeController__button {
                opacity: 1;
                -webkit-transition: opacity 0.15s;
                /* Safari */
                transition: opacity 0.15s;
              }
              
              .VolumeController__volumeRange {
                display: inline-block;
                vertical-align: middle;
                -webkit-transition: width 1.42s;
                /* Safari */
                transition: width 1.42s;
              }
              .VolumeController__volumeRange:focus {
                width: 120px;
                -webkit-transition: width 0.52s;
                /* Safari */
                transition: width 0.52s;
              }
              .VolumeController__volumeRange:focus .VolumeController__button {
                opacity: 1;
                -webkit-transition: opacity 0.15s;
                /* Safari */
                transition: opacity 0.15s;
              }
              .VolumeController__volumeRange .VolumeController__button {
                opacity: 0;
                -webkit-transition: opacity 1.32s;
                /* Safari */
                transition: opacity 1.32s;
              }
              
              .VolumeController__onOffButton {
                display: inline-block;
                vertical-align: middle;
                width: 45px;
                max-width: 45px;
                height: 45px;
                max-height: 45px;
                margin-left: 0;
                font-size: 35px;
                vertical-align: middle;
              }
              @media only screen and (max-width: 767px) {
                .VolumeController__onOffButton {
                  padding-left: 0;
                }
              }
              
              .VolumeController__off {
                color: #adadad;
              }
              
              /* @media only screen and (max-width: 767px) {
                  .volumeRange {
                      display: none;
                  }
              } */
              .VolumeController__button {
                fill: #999999;
                border-radius: 3px;
                border: 0;
                width: 40px;
                height: 35px;
                margin: 10px;
                max-width: 40px;
                max-height: 35px;
                cursor: pointer;
                background-color: transparent;
              }
              `}</style>
      </React.Fragment>
    );
  }

  renderVolumRange() {
    const customclass = this.props.options && this.props.options.volumnRangeClassName ?
      this.props.options && this.props.options.volumnRangeClassName : '';
    return (
      <RangeComponent
        data={{
          accessabiltyText: 'Volume',
          mute: this.state.mute,
          reportTitle: 'Volume Slider',
          valueMax: 100,
        }}
        options={{
          className: customclass,
          reflect: this.state.mute ? 0 : this.state.volume,
          tooltip: false,
          modal: this.props.options?.modal
        }}
        events={{ update: this.handlevolumeRange }}
      />
    );
  }

  handlevolumeRange(value: number) {
    this.setState({ volume: value, mute: value <= 0 ? true : false });
    if (this.props.events && this.props.events.onVolumeChange) {
      this.props.events.onVolumeChange(value <= 0 ? true : false, value);
    }
  }

  renderOnOffButton(volumeValue: number) {
    let onOffClass = "color-gray-500";
    const cssClasses = [this.props.options && this.props.options.buttonClassName,
    "VolumeController__onOffButton", "VolumeController__button"];
    let volumeIcon = volumeIconDefault;

    if (!this.state.mute && this.state.volume > 0) {
      if (this.state.volume > 66) {
        onOffClass = '';
        volumeIcon = volumeIconFull;
      } else if (this.state.volume > 33) {
        volumeIcon = volumeIconHalf;
      } else if (this.state.volume > 0) {
        volumeIcon = volumeIconLow;
      }
    }

    cssClasses.push(onOffClass);

    return (
      <button
        className={cssClasses.join(' ')}
        aria-label={'Toggle Mute'}
        title={'Video ' + (volumeValue > 0 ? 'Unmuted' : 'Muted')}
        aria-pressed={volumeValue > 0 ? true : false}
        onClick={this.handlevolumeClick}
        report-title="Mute toggle"
      >
        <IconSvg size={IconSvgSizes.MD} svgNodeStr={volumeIcon} altText={'volumeIcon ' + (volumeValue > 0 ? 'Unmuted' : 'Muted')}/>
      </button>
    );
  }

  handlevolumeClick() {
    this.setState({ mute: !this.state.mute });
    if (this.props.events && this.props.events.onClick) {
      this.props.events.onClick(!this.state.mute, this.state.volume);
    }
  }
}

export default VolumeController;